export default "__VITE_ASSET__DR4uwyO8__"